// Audit 2026-05-29 [LOW]: i tipi di dominio (Order, OrderState, Marketplace,
// FornitoreKind, PaymentState) sono stati spostati in ``../types``. Qui
// restano SOLO le fixtures di mock. Re-export per non rompere i moduli che
// finora importavano i tipi da questo file (api.ts, OrdiniPage, ecc.).
import type { Order } from "../types";
export type { FornitoreKind, Marketplace, Order, OrderState, PaymentState } from "../types";

export const mockOrders: Order[] = [
  {
    id: "POL-2026-04812",
    productName: "Divano angolare 3 posti in tessuto grigio — collezione Selin",
    sku: "VE16205LIT003-CT",
    customer: {
      name: "Giulia Serafini",
      address: "Via di Pontana Vecchia 84",
      city: "00044 Frascati (RM)",
      email: "g.serafini@gmail.com",
      phone: "+39 701 7679",
    },
    total: 803,
    marketplace: "Amazon",
    state: "in_lavorazione",
    paymentState: "paid",
    fornitore: { name: "ITYH-08089", kind: "ityhome" },
    corriere: "SDA",
    colli: 2,
    costo: 187,
    margin: "+51,2%",
    // Mail in outbox: i test del bottone Mail usano questo primo mock.
    hasMail: true,
  },
  {
    id: "POL-2026-04808",
    productName: "Letto matrimoniale contenitore 160×200 — rivestimento velluto",
    sku: "BSVED1025CCS-LIC-BF",
    customer: {
      name: "Carlotta Marini",
      address: "Strada delle Quinte 12",
      city: "10131 Torino (TO)",
      email: "c.marini@gmail.com",
      phone: "+39 333 4421",
    },
    total: 398,
    marketplace: "Amazon",
    state: "in_lavorazione",
    paymentState: "paid",
    fornitore: { name: "ITAM-04421", kind: "itamoby" },
    corriere: "GLS",
    colli: 2,
    costo: 142,
    margin: "+38,6%",
  },
  {
    id: "POL-2026-04795",
    productName: "Materasso memory foam 160×200 H26 — certificato Oeko-Tex",
    sku: "MAT-MEM-160-200",
    customer: {
      name: "Mariaterea Tiscione",
      address: "Via Roma 18",
      city: "20121 Milano (MI)",
      email: "mariaterea@gmail.com",
      phone: "+39 348 9942",
    },
    total: 329,
    marketplace: "Shopify",
    state: "pronto",
    paymentState: "paid",
    fornitore: { name: "AS-MAT", kind: "allservice" },
    corriere: "BRT",
    colli: 1,
    costo: 198,
    margin: "+24,8%",
  },
  {
    id: "POL-2026-04789",
    productName: "Sedia da ufficio ergonomica — schienale regolabile in mesh",
    sku: "MOSO46S-CT",
    customer: {
      name: "Rita Di Antonio",
      address: "Via Don Bosco 22",
      city: "70125 Bari (BA)",
      email: "rita.dia@libero.it",
      phone: "+39 339 1212",
    },
    total: 99,
    marketplace: "eBay",
    state: "spedito",
    paymentState: "shipped",
    fornitore: { name: "ITYH-08123", kind: "ityhome" },
    corriere: "SDA",
    colli: 1,
    costo: 49,
    margin: "+45,3%",
    // Arrivata rotta e rispedita: la colonna Spedizione mostra i due codici.
    trackingCode: "3UW1RX0012345",
    lastTrackingEvent: { label: "Consegnata", delivered: true, location: "Bari", at: "" },
    replacementTracking: ["3UW1RX0098765"],
  },
  {
    id: "POL-2026-04781",
    productName: "Tavolo allungabile 140-200 cm noce naturale — gambe metallo nero",
    sku: "VELET2NDLE0R1-TB",
    customer: {
      name: "Bartolomeo Acampora",
      address: "Via Fontana 9",
      city: "80131 Napoli (NA)",
      email: "b.acampora@gmail.com",
      phone: "+39 720 9112",
    },
    total: 320,
    marketplace: "Amazon",
    state: "spedito",
    paymentState: "shipped",
    fornitore: { name: "ITAM-04415", kind: "itamoby" },
    corriere: "GLS",
    colli: 3,
    costo: 167,
    margin: "+32,1%",
  },
  {
    id: "POL-2026-04776",
    productName: "Lampada da terra LED dimmerabile — base marmo bianco carrara",
    sku: "LMP-LED-FM-WH",
    customer: {
      name: "Sofia Benedetti",
      address: "Corso Garibaldi 55",
      city: "50123 Firenze (FI)",
      email: "s.benedetti@hotmail.it",
      phone: "+39 338 5577",
    },
    total: 185,
    marketplace: "Shopify",
    state: "annullato",
    paymentState: "cancelled",
    fornitore: { name: "ITAM-04403", kind: "itamoby" },
    corriere: "BRT",
    colli: 1,
    costo: 89,
    margin: "+41,7%",
  },
  {
    id: "POL-2026-04770",
    productName: "Cassettiera 5 cassetti laccata bianca opaca — maniglie ottone",
    sku: "CAS5-LAC-WH-OR",
    customer: {
      name: "Marco Ferragni",
      address: "Via Dante Alighieri 3",
      city: "37121 Verona (VR)",
      email: "m.ferragni@gmail.com",
      phone: "+39 347 2211",
    },
    total: 249,
    marketplace: "Amazon",
    state: "nuovo",
    paymentState: "ordered_unpaid",
    fornitore: { name: "ITYH-08201", kind: "ityhome" },
    corriere: "SDA",
    colli: 2,
    costo: 121,
    margin: "+37,8%",
  },
  {
    id: "POL-2026-04762",
    productName: "Poltrona relax reclinabile manuale — tessuto beige 100% poliestere",
    sku: "PLT-RLX-BEI-M",
    customer: {
      name: "Anna Colombo",
      address: "Via Cavour 14",
      city: "16121 Genova (GE)",
      email: "a.colombo@libero.it",
      phone: "+39 335 9988",
    },
    total: 159,
    marketplace: "Privato",
    state: "in_lavorazione",
    paymentState: "paid",
    fornitore: { name: "AS-POL", kind: "allservice" },
    corriere: "GLS",
    colli: 1,
    costo: 74,
    margin: "+46,9%",
  },
];
